<template>
  <component :is="'page-node-dom'" :mConfig="mConfig">
    <template v-for="(item, index) in mConfig.children">
      <page-preview-dom :mConfig="item" :key="index"></page-preview-dom>
    </template>
  </component>
</template>

<script>
import PageNodeDom from './PageNodeDom.vue'

export default {
  name: 'PagePreviewDom',
  components: {
    PageNodeDom
  },
  props: {
    // 页面配置
    mConfig: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>
